/**
 * Snapshot da sessão no `localStorage` — o que permite reidratar a UI no
 * carregamento sem esperar a rede.
 *
 * Genérico no formato guardado de propósito: os apps divergem no que cabe no
 * snapshot (o admin guarda `roles`, o user-dashboard não), e nada aqui depende
 * do formato — só de ele ser serializável.
 */
export class AuthStorageDatasource<TStoredAuth> {
  private readonly key: string;

  constructor(key = '@primum:auth') {
    this.key = key;
  }

  /**
   * `null` também quando o valor guardado está corrompido: um snapshot ilegível
   * é indistinguível de não ter snapshot, e estourar aqui derrubaria o
   * carregamento inteiro do app por causa de um cache local.
   */
  get(): TStoredAuth | null {
    try {
      const raw = localStorage.getItem(this.key);
      if (!raw) return null;
      return JSON.parse(raw) as TStoredAuth;
    } catch {
      return null;
    }
  }

  save(auth: TStoredAuth): void {
    localStorage.setItem(this.key, JSON.stringify(auth));
  }

  clear(): void {
    localStorage.removeItem(this.key);
  }
}
